import React, { useState } from 'react';
import { Translations } from '../i18n/translations';
import { CrownStarIcon, ChevronIcon } from './icons';
export const Testimonials: React.FC<{
  t: Translations;
}> = ({
  t
}) => {
  const testimonials = [t.testimonials.t1, t.testimonials.t2, t.testimonials.t3, t.testimonials.t4];
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="bg-beige py-24 overflow-hidden relative" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 lg:px-8" data-id="element-340">
        <h2 className="text-3xl lg:text-4xl font-serif text-ink mb-16 text-center" data-id="element-341">
          {t.testimonials.title}
        </h2>

        <div className="relative max-w-4xl mx-auto" data-id="element-342">
          {/* Desktop Grid (shows 3) / Mobile Carousel (shows 1) */}
          <div className="hidden lg:grid grid-cols-3 gap-8" data-id="element-343">
            {testimonials.slice(0, 3).map((test, i) => <TestimonialCard key={i} test={test} data-id="element-344" />)}
          </div>

          <div className="lg:hidden" data-id="element-345">
            <TestimonialCard test={testimonials[currentIndex]} data-id="element-346" />

            <div className="flex items-center justify-center space-x-6 mt-8" data-id="element-347">
              <button onClick={prev} className="text-gold hover:text-gold-dark p-2" data-id="element-348">
                <ChevronIcon direction="left" data-id="element-349" />
              </button>
              <div className="flex space-x-2" data-id="element-350">
                {testimonials.map((_, i) => <div key={i} className={`w-2 h-2 rounded-full ${i === currentIndex ? 'bg-gold' : 'bg-gold/30'}`} data-id="element-351" />)}
              </div>
              <button onClick={next} className="text-gold hover:text-gold-dark p-2" data-id="element-352">
                <ChevronIcon direction="right" data-id="element-353" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const TestimonialCard = ({
  test
}: {
  test: any;
}) => <div className="bg-cream p-8 rounded-sm shadow-sm flex flex-col items-center text-center border border-transparent hover:border-gold/20 transition-soft" data-id="element-354">
    <div className="w-16 h-16 rounded-full bg-beige border border-gold/30 mb-6 flex items-center justify-center overflow-hidden" data-id="element-355">
      <span className="font-serif text-xl text-gold" data-id="element-356">
        {test.name.charAt(0)}
      </span>
    </div>
    <div className="flex space-x-1 mb-6 text-gold" data-id="element-357">
      {[...Array(5)].map((_, i) => <CrownStarIcon key={i} data-id="element-358" />)}
    </div>
    <p className="font-serif text-lg italic text-ink/80 mb-6 leading-relaxed flex-1" data-id="element-359">
      "{test.quote}"
    </p>
    <div className="flex flex-col items-center" data-id="element-360">
      <span className="text-sm font-medium text-ink mb-1" data-id="element-361">{test.name}</span>
      <span className="text-[10px] uppercase tracking-widest text-gold" data-id="element-362">
        {test.surgery}
      </span>
    </div>
  </div>;